
<div class="fixed z-50 top-4 right-4">
  <div *ngIf="showToast" id="toast-{{type}}"
    class="flex items-center w-full max-w-xs p-4 mb-4 text-gray-500 bg-white rounded-lg shadow-sm dark:text-gray-400 "
    role="alert">

    <div [ngClass]="{
            'text-green-500 bg-green-100 dark:bg-green-800 dark:text-green-200' : type==='success',
            'text-red-500 bg-red-100 dark:bg-red-800 dark:text-red-200': type==='danger',
            'text-orange-500 bg-orange-100 dark:bg-orange-700 dark:text-orange-200': type==='warning'
        }"
      class="inline-flex items-center justify-center w-8 h-8 rounded-lg shrink-0 "
      *ngIf="iconPaths[type]">
      <svg class="w-5 h-5" aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor" viewBox="0 0 20 20">
        <path [attr.d]="iconPaths[type].path"></path>
      </svg>
      <span class="sr-only">{{ iconPaths[type].label }}</span>
    </div>

    <!-- <div *ngIf="statusMessages[type]" class="text-sm font-normal ms-3">
            {{ statusMessages[type] }}
          </div> -->
    <div *ngIf="message" class="text-sm font-normal ms-3">
      {{ message }}
    </div>

    <button type="button"
      (click)="closeToast()"
      class="ms-auto -mx-1.5 -my-1.5 bg-white text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex items-center justify-center h-8 w-8 dark:text-gray-500 hover:text-gray "
      aria-label="Close">
      <span class="sr-only">Close</span>
      <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 14 14">
        <path stroke="currentColor" stroke-linecap="round"
          stroke-linejoin="round" stroke-width="2"
          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
      </svg>
    </button>
  </div>
</div>
